import React from "react";
import { PageContextUtils, UrlUtils } from "../../../../utils";
import {
  HomeSectionMenuItem,
  Item,
  MenuItem
} from "../../../../components/Menu";
import { LocalizationMessages } from "../../../../localization/messages";
import { CategoryType } from "../../../../constants";
import { links } from "./Config.resource";
import { useCategoriesSetter } from "../../../../hooks";

const getHomeSectionItems = () => {
  return {
    home: new Item({
      URL: UrlUtils.getSEOUrl(links.pokerUrl),
      title: LocalizationMessages.home,
      iconKey: "home"
    }),
    howToPlay: new Item({
      URL: UrlUtils.getSEOUrl(links.howToPlay),
      title: LocalizationMessages.howToPlay,
      iconKey: "question-mark"
    }),
    depositAndCashout: new Item({
      URL: UrlUtils.getSEOUrl(links.depositAndCashout),
      title: LocalizationMessages.depositAndCashout,
      iconKey: "real-money-poker"
    }),
    specialOffers: new Item({
      URL: UrlUtils.getSEOUrl(links.specialOffers),
      title: LocalizationMessages.specialOffers,
      iconKey: "special-offers"
    }),
    tournamentInfo: new Item({
      URL: UrlUtils.getSEOUrl(links.tournamentInfo),
      title: LocalizationMessages.tournamentInfo,
      iconKey: "tournaments"
    })
  };
};

const HomeSection = () => {
  const items = React.useMemo(getHomeSectionItems, []);
  const { langId } = PageContextUtils.getLocalizationData();

  useCategoriesSetter(CategoryType.HomeSection, items);

  const selectableMenuItems = Object.keys(items).map(key => {
    const item = items[key];

    return <HomeSectionMenuItem key={key} item={item} dataTestId={key} />;
  });

  const eMagazineItem = new Item({
    URL: UrlUtils.getSEOUrl(links.eMagazine),
    title: LocalizationMessages.eMagazine,
    iconKey: "e-magazine",
    target: "_blank"
  });

  return (
    <>
      {selectableMenuItems}
      {langId.toLowerCase() !== "ua" && (
        <MenuItem item={eMagazineItem} dataTestId="uc-eMagazine" />
      )}
    </>
  );
};

export default React.memo(HomeSection);
